export enum RouteWaypointType { 
    TAKE_OFF = 'TAKE_OFF', 
    DESTINATION = 'DESTINATION', 
    WAYPOINT = 'WAYPOINT', 
}